import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "external-mam-search-results-name-cell",
  template: `<img [src]="thumb" width="48px" *ngIf="thumb" /><span
      *ngIf="name"
      >{{ name }}</span
    >`,
  styleUrls: ["./external-mam-search-results-name-cell.component.scss"],
})
export class ExternalMAMSearchResultsNameCell
  implements ICellRendererAngularComp
{
  thumb!: string;
  name!: string;

  agInit(params: ICellRendererParams): void {
    this.updateDisplayValue(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateDisplayValue(params);
    return true;
  }

  private updateDisplayValue(params: ICellRendererParams): void {
    if (!params.data) {
      return;
    }
    this.thumb = params.data.images.thumbnail?.src || "";
    this.name = params.data.name;
  }
}
